module.exports = __webpack_public_path__ + "static/media/vault-color-med.48e15725.png";